const salaryInsightTexts = [
	{
		path: '/jobs/salary-insight-texts/list',
		name: 'jobs-salary-insight-texts-list',
		component: () => import('@/views/jobs/salary-insight-texts/list.vue'),
		meta: { layout: 'content', module: 'MGJ,salary' },
	},
]

export default salaryInsightTexts
